// Centralised business info — keep in sync with site copy.
export const BUSINESS = {
    name: "Call The Handyman",
    tagline: "Reliable. Local. No Job Too Small.",
    phone: "+447356 250224",
    phoneTel: "+447356 250224",
    whatsappNumber: "447356250224",
    whatsappUrl:
        "https://wa.me/447356250224?text=" +
        encodeURIComponent(
            "Hi, I'd like a quote for some handyman work please.",
        ),
    email: "jobs@callthehandyman.co.uk",
    area: "Dumbarton and surrounding areas",
    hours: [
        { day: "Monday – Friday", time: "9:00am – 5:00pm" },
        { day: "Saturday", time: "9:00am – 4:00pm" },
        { day: "Sunday", time: "Closed" },
    ],
    logo: "/assets/logo.png",
    logoWhite: "/assets/logo_white.png",
    facebookUrl: "https://www.facebook.com/CallTheHandyman24/",
};
